export var NotificationAction;
(function (NotificationAction) {
    NotificationAction["OpenURL"] = "openURL";
})(NotificationAction || (NotificationAction = {}));
export var NotificationCategory;
(function (NotificationCategory) {
    NotificationCategory["NewMessage"] = "NEW_MESSAGE";
})(NotificationCategory || (NotificationCategory = {}));
//# sourceMappingURL=notification-action.const.js.map